import { render, staticRenderFns } from "./DisplayInfo.vue?vue&type=template&id=0a4aa4a4&scoped=true"
import script from "./DisplayInfo.vue?vue&type=script&lang=js"
export * from "./DisplayInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4aa4a4",
  null
  
)

export default component.exports